import moment from 'moment';
import React, { useEffect, useState } from 'react';
import Flatpickr from 'react-flatpickr';
import { useDispatch } from 'react-redux';
import { useParams } from 'react-router-dom';
import Select from 'react-select';
import { toast } from 'react-toastify';
import { Col, Modal, ModalBody, ModalHeader, Row } from 'reactstrap';
import { editLicenseAPI } from '../../apiConfig/apiCall';
import useReactSelectCustomStyle from '../../hooks/useReactSelectCustomStyle';
import { getClientLicenseList } from '../../slices/LicenseList/thunk';

export default function EditLicenseModal({ editLicenseModal, handleEdit, licenseData, setEditLicenseModal }) {

    const params = useParams();
    const dispatch = useDispatch();

    const selectBoxCustomStyles = useReactSelectCustomStyle();
    const [status, setStatus] = useState(null);

    useEffect(() => {
        if (licenseData?.status) {
            const defaultStatus = statusOptions.find(
                (option) => option.value === licenseData.status
            );
            setStatus(defaultStatus || { label: 'ACTIVE', value: 'ACTIVE' });
        }
    }, [licenseData]);

    const [formData, setFormData] = useState({
        id: licenseData.id,
        startDate: licenseData.startDate,
        dueDate: licenseData.dueDate,
        status: { value: licenseData.status, label: licenseData.status },
    });

    const statusOptions = [
        { value: 'ACTIVE', label: 'ACTIVE' },
        { value: 'INACTIVE', label: 'INACTIVE' },
    ];

    const handleDateChange = (field, date) => {
        setFormData((prevState) => ({
            ...prevState,
            [field]: date,
        }));
    };

    const handleStatusChange = (selectedOption) => {
        setStatus(selectedOption);
    };


    const handleSubmit = async () => {
        const submitData = {
            id: licenseData.id,
            startDate: formData.startDate || licenseData.startDate,
            dueDate: formData.dueDate || licenseData.dueDate,
            status: status.value,
        };
        const apiResponse = await editLicenseAPI(submitData);
        if (apiResponse.status === 201) {
            setEditLicenseModal(false);
            dispatch(getClientLicenseList(params.id));
            toast.success('License Updated Successfully');
        } else {
            toast.error('Failed to Update License');
        }
    };

    return (
        <Modal isOpen={editLicenseModal} toggle={handleEdit} size="sm" backdrop={'static'}>
            <ModalHeader toggle={handleEdit}>Edit License</ModalHeader>
            <ModalBody>
                <Row>
                    <Col lg={12}>
                        <div>
                            <label htmlFor="startDate" className="form-label">Start Date</label>
                            <Flatpickr
                                id="startDate"
                                options={{ dateFormat: "Y-m-d" }}
                                value={licenseData.startDate}
                                onChange={(date) => handleDateChange('startDate', moment(date[0]).format('YYYY-MM-DD'))}
                                className="form-control"
                            />
                        </div>
                    </Col>
                    <Col lg={12}>
                        <div className="mt-3">
                            <label htmlFor="dueDate" className="form-label">Due Date</label>
                            <Flatpickr
                                id="dueDate"
                                options={{ dateFormat: "Y-m-d" }}
                                value={licenseData.dueDate}
                                onChange={(date) => handleDateChange('dueDate', moment(date[0]).format('YYYY-MM-DD'))}
                                className="form-control"
                            />
                        </div>
                    </Col>
                    <Col lg={12}>
                        <div className="mt-3">
                            <label htmlFor="statusSelect" className="form-label">Status</label>
                            <Select
                                id="statusSelect"
                                options={statusOptions}
                                value={status}
                                onChange={handleStatusChange}
                                classNamePrefix="select"
                                styles={selectBoxCustomStyles}
                            />
                        </div>
                    </Col>
                    <Col lg={12}>
                        <div className="mt-3 text-end">
                            <button className="btn btn-primary" onClick={handleSubmit}>Submit</button>
                        </div>
                    </Col>
                </Row>
            </ModalBody>
        </Modal>
    );
}